import '@/style/index.scss'

import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import mixin from './mixins'
import './pwa/registerServiceWorker'
import useAuth from '@/utils/useAuth'

const bootstrap = async () => {
  const app = createApp(App).use(store).use(router).mixin(mixin)
  const { ensureAuthenticated } = useAuth()

  try {
    await ensureAuthenticated()
  } catch (error) {
    console.error(error)
  }

  app.mount('#app')
}

bootstrap()
